
module.exports = { 
      attributes: {"title":"footer","logoFooter":"/img/logo-green-white.png","addressFooter":"Immeuble Kaori\\\n45 bis Route du Port Despointes\\\n98800 Nouméa - Nouvelle Calédonie","phoneFooter":"24 63 97","mailFooter":"conseil@neo.nc","opentimeFooter":"8h-12h / 14h-18h"},
    
      html: "",
     }